<template>
	<div class="college">
    <div>
      &nbsp;
      <el-button size="small" type="primary" class="el-icon-plus buttonAdd" @click="showDialog('new')"> 新增</el-button>
    </div>
     <el-collapse v-model="activeNames" class="collapse">
        <el-collapse-item v-for="college in collegeList" :title="college.name"
          :key="college.id" :name="college.id" class="collapseItem">
            <div v-for="item in college.category" :key="item.id" class="collapse-item-div"
             @click="showDialog(college.id, item)">
              <div style="display:inline-block;width:30%;">  {{ item.title }}  </div>
              <div style="display:inline-block;"> {{ item.code }}  </div>
            </div>
        </el-collapse-item>
    </el-collapse>
    <el-dialog  title="編輯學院主題分類" :show-close="false" :visible.sync="dialogFormVisible" customClass="dialogWidth">
      <el-form :model="form" :rules="rules" ref="form" label-position="top">
        <el-form-item label="隸屬學院" prop="collegeId">
          <el-select v-model.number="selectedCollege" placeholder="請選擇學院" style="width:100%" @change="collegeSel">
            <el-option v-for="college in collegeList" :key="college.id" :label="college.name" :value="college.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="類別名稱" prop="title">
          <el-input v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item label="類別名稱縮寫" prop="code">
          <el-input v-model="form.code"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button v-if="isEdit" type="text" @click="deleteCategory" style="float: left;">刪除分類</el-button>
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button v-if="isEdit" type="primary" @click="editCategory">儲存</el-button>
        <el-button v-else type="primary" @click="addCategory">新增</el-button>
      </div>
    </el-dialog>
  </div>
  
</template>
<script>
  import API from '../../api/api';
  export default {
    name: 'College',
    props: {
        collegeList: {
            type: Array
        }
    },
    data() {
      return {
        dialogFormVisible: false,
        isEdit: false,
        selectedCollege: null,
        form: {
          collegeId: null,
          id: '',
          title: '',
          code: '',
        },
        activeNames: ['1'],
        rules: {
          collegeId: [
            { required: true, message: '請選擇隸屬學院' }
          ],
          title: [
            { required: true, message: '請輸入類別名稱', trigger: 'blur' },
          ],
          code: [
            { required: true, message: '請輸入類別名稱縮寫', trigger: 'blur' },
          ],
        },
      };
    },
    methods: {
      reloadData() {
        this.$emit('getCategoriesGroup');
      },
      collegeSel(val) {
        this.form.collegeId = val;
      },
      showDialog(collegeId, item) {
        if (collegeId === 'new') {
          this.isEdit = false;
          this.form = {};
          this.selectedCollege = null;
        } else if (item){
          this.isEdit = true;
          this.form = Object.assign({}, item);
          this.form.collegeId = collegeId;
          this.selectedCollege = collegeId;
        }

        this.dialogFormVisible = true;
        if (this.$refs["form"] !== undefined) {
          this.$refs["form"].resetFields();
        }
      },
      addCategory() {
        this.$refs["form"].validate((valid) => {
          if (valid) {
            API.addCategory(this.form.code, this.form.title, this.form.collegeId).then((response) => {
              if(response.status) {
                redirectLogin(response.data);
                if(!JSON.parse(response.request.response).error_msg) {
                  this.$message.error('新增分類錯誤!');
                } else {
                  this.$message.error(JSON.parse(response.request.response).error_msg);
                }
              } else {
                this.reloadData();
                this.$store.state.isCategoryUpdated = true;
                this.dialogFormVisible = false;
              }
            });
          } else {
            return false;
          }
        });
      },
      editCategory() {
        this.$refs["form"].validate((valid) => {
          if (valid) {
            API.fixCategory(this.form.id, this.form.title,
             this.form.code ,this.form.collegeId).then((response) => {
              if(response.status) {
                redirectLogin(response.data);
                if(!JSON.parse(response.request.response).error_msg) {
                  this.$message.error('儲存編輯結果錯誤!');
                } else {
                  this.$message.error(JSON.parse(response.request.response).error_msg);
                }
              } else {
                this.reloadData();
                this.$store.state.isCategoryUpdated = true;
                this.dialogFormVisible = false;
              }
            });
          } else {
            return false;
          }
        });
      },
      deleteCategory() {
        var deletedId = this.form.id;
        this.$confirm('刪除 E-learning 分類，會造成隸屬該分類下的 E-learning 資料失去分類，需重新編輯設定', '注意', {
          confirmButtonText: '確定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          API.deleteCategory(deletedId).then((response) => {
            if(response.status) {
              redirectLogin(response.data);
              if(!JSON.parse(response.request.response).error_msg) {
                this.$message.error('刪除分類錯誤!');
              } else {
                this.$message.error(JSON.parse(response.request.response).error_msg);
              }
            } else {
              this.reloadData();
              this.$store.state.isCategoryUpdated = true;
              const indexOfDeleted = this.$store.state.checkedCategoryListForTrend.indexOf(deletedId);
              if (indexOfDeleted !== -1) {
                this.$store.state.checkedCategoryListForTrend.splice(indexOfDeleted, 1);
              }
              this.dialogFormVisible = false;
            }
          });
          
        }).catch(() => {});
      },
    },
		mounted() {
			this.reloadData();
		},
  }
</script>

<style lang="scss">
.college {
    background-color: white;

    .buttonAdd {
      float: right;
      margin-top: 10px;
      margin-right: 10px;
      font-size: 12px;
      font-weight: 500;
    }

    .collapse {
      margin-top: 30px;
    }

    .el-collapse-item__header {
        background-color: #F7F7F7;
        font-size: 16px;
    }
    .el-collapse-item__header__arrow {
        float: right;
        margin-top: 15px;
        margin-right: 20px;
    }

    .el-collapse-item__content {
      padding: 0;

      .collapse-item-div {
        background-color: white;
        border: 1px solid #EEE;
        font-size: 14px;
        line-height: 40px;
        padding-left: 25px;
        cursor: pointer;
      }

      .collapse-item-div:hover {
        color: #2E90F4;
        background: #F0F7FF;
        border: 1px solid #2E90F4;
      }
    }

    .dialogWidth {
      width: 450px;
    }

    .el-form-item__content {
      margin-left: 0px;
    }
}
</style>


// WEBPACK FOOTER //
// College.vue?43de6797